import { ReactComponent as DebrisDumpSvg } from 'images/icons/debris_dump.svg'
import { ReactComponent as LotNotSetSvg } from 'images/icons/lot_not_set.svg'
import { ReactComponent as MaintenanceUniversalSvg } from 'images/icons/maintenance_universal.svg'
import { ReactComponent as ParkingSvg } from 'images/icons/parking.svg'
import { ReactComponent as ChargingSvg } from 'images/icons/plug_in.svg'
import { ReactComponent as RefillingSvg } from 'images/icons/refilling.svg'
import { ReactComponent as WashingSvg } from 'images/icons/washing.svg'
import { ReactComponent as WasteWaterDrainSvg } from 'images/icons/waste_water_drain.svg'
import { LOT_TYPE } from 'utils/lotInterfaces'

import type { ServiceCalibCatalogItem } from './serviceCalibTypes'

import style from './ServiceCalibCatalog.module.css'

function iconForLotType(lotType?: number) {
  switch (lotType) {
    case LOT_TYPE.CHARGING:
      return <ChargingSvg className={style.pointIcon} aria-hidden />
    case LOT_TYPE.WASHING:
      return <WashingSvg className={style.pointIcon} aria-hidden />
    case LOT_TYPE.PARKING:
      return <ParkingSvg className={style.pointIcon} aria-hidden />
    case LOT_TYPE.REFILLING:
      return <RefillingSvg className={style.pointIcon} aria-hidden />
    case LOT_TYPE.DEBRIS_DUMP:
      return <DebrisDumpSvg className={style.pointIcon} aria-hidden />
    case LOT_TYPE.NOT_SET:
      return <LotNotSetSvg className={style.pointIcon} aria-hidden />
    default:
      return <LotNotSetSvg className={style.pointIcon} aria-hidden />
  }
}

export function ServiceCalibPointIcon({
  item,
  primaryAction,
}: {
  item: ServiceCalibCatalogItem
  /** Optional selected/allowed action — used when lotType is NOT_SET or mismatched. */
  primaryAction?: string | null
}) {
  if (item.target === 'maintenance_point') {
    if (item.maintenancePointType === 'debris_dump') {
      return <DebrisDumpSvg className={style.pointIcon} aria-hidden />
    }
    if (item.maintenancePointType === 'universal') {
      return <MaintenanceUniversalSvg className={style.pointIcon} aria-hidden />
    }
    return <WasteWaterDrainSvg className={style.pointIcon} aria-hidden />
  }

  if (item.lotType != null && item.lotType !== LOT_TYPE.NOT_SET) {
    return iconForLotType(item.lotType)
  }

  // Fallback by primary action label/code when lot type is missing.
  const action = (primaryAction || '').toLowerCase()
  if (action.includes('charge')) {
    return <ChargingSvg className={style.pointIcon} aria-hidden />
  }
  if (action.includes('wash')) {
    return <WashingSvg className={style.pointIcon} aria-hidden />
  }
  if (action.includes('park')) {
    return <ParkingSvg className={style.pointIcon} aria-hidden />
  }
  if (action.includes('refill')) {
    return <RefillingSvg className={style.pointIcon} aria-hidden />
  }

  return iconForLotType(item.lotType)
}
